import Canvas from "components/Canvas/Canvas";
import GameControls from "components/GameControls/GameControls";
import GameStats from "components/GameStats/GameStats";
import GoHome from "components/GoHome/GoHome";
import PausedOverlay from "components/PausedOverlay/PausedOverlay";
import TowerPlacementOverlay from "components/TowerPlacementOverlay/TowerPlacementOverlay";
import Towers from "components/Towers/Towers";
import WaveCountdown from "components/WaveCountdown/WaveCountdown";

const Playground = () => {
  return (
    <div style={{ position: "relative" }}>
      <Canvas />
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
        }}
      >
        <GameStats />
        <GameControls />
      </div>
      <Towers />
      <TowerPlacementOverlay />
      <PausedOverlay />
      <GoHome />
      <WaveCountdown />
    </div>
  );
};

export default Playground;
